module.exports = __webpack_public_path__ + "img/rainy-6.d235ab65.svg";